import { EngineFormItem } from '@models/client-portal/engine-client-intake';
import { ClientIntakeFormItemsPathParams } from '../clientIntakeFormItems.firebase.repo';

export class SetClientIntakeFormItemsConnection {
	static readonly type =
		'[Client Intake Form Items] Set client intake form items connection';
	constructor(
		public connect: boolean,
		public pathParams: ClientIntakeFormItemsPathParams,
	) {}
}

export class ClearClientIntakeFormItemsConnectionAndState {
	static readonly type =
		'[Client Intake Form Items] Clear client intake form items connection and state';
}

export class SetClientIntakeFormItems {
	static readonly type =
		'[Client Intake Form Items] Set client intake form items';
	constructor(public items: EngineFormItem[]) {}
}

export class UpsertClientIntakeFormItems {
	static readonly type =
		'[Client Intake Form Items] Upsert client intake form items';
	constructor(public items: EngineFormItem[]) {}
}

export class UpdateClientIntakeFormItem {
	static readonly type =
		'[Client Intake Form Items] Update client intake form item';
	constructor(
		public itemId: string,
		public updates: Partial<EngineFormItem>,
	) {}
}

export class DeleteClientIntakeFormItem {
	static readonly type =
		'[Client Intake Form Items] Delete client intake form item';
	constructor(public itemId: string) {}
}
